module.exports = __webpack_public_path__ + "static/media/7.a6e87a79.jpg";